<template>
    <div class="main">
        <download-Popup />

        <p v-if="isOperamini" class="operamini-tips">
            Untuk memberi Anda pengalaman yang lebih baik, silakan unduh aplikasi profesional kami.
        </p>

        <navVue :subtitleData="getMatchSubTabList" :navSelected="currentNavTag" />

        <div class="contentWrap" id="contentWrap">
            <!-- 没数据 -->
            <nodata v-if="getMatchNoDataMode && !getMatchLoadingShow" :whiteMode="true" />
            <!-- loading -->
            <loading v-if="getMatchLoadingShow" />

            <!-- 列表详情 -->
            <div v-if="!getMatchNoDataMode && !getMatchLoadingShow" class="listwrap" id="listwrap" >
                <div v-for="(item, key, index) in getFinalListSplitDateData" :key="index">
                    <p class="dateTit">
                        <span>{{key}}</span>
                        <em>{{item.localdate}}</em>
                    </p>

                    <div v-for="(elem, index) in item"  class="sameDateData" :id="`match-${elem.match_id}`" :key="index">
                        <div class="list">
                            <div class="clearfix" @click="handleJumpMatchDetailPage(elem)">
                                <dl class="flwrap">
                                    <dt><img :data-src="getImgSrc(elem.team_A_logo)" v-team-logo class="teamlogo"></dt>
                                    <dd>{{elem.team_A_name}}</dd>
                                </dl>

                                <!-- 未开始比赛 -->
                                <div v-if="elem.status==='Fixture'" class="unStart_competewrap competewrap">
                                    <div class="unStartInfor">
                                        <p class="competename">
                                            {{tran12(elem.localdate.local_hms)}}
                                            {{elem.competition_name}} {{elem.gameweek}}
                                        </p>
                                        <p class="vs">vs</p>

                                        <AppMatchTag v-if="elem.live_icon" :type="elem.live_icon.type"/>
                                    </div>
                                </div>

                                <!-- 暂停等状态比赛 -->
                                <div v-else-if="elem.status==='Postponed'||elem.status==='Cancelled'||elem.status==='Suspended'" class="unStart_competewrap competewrap">
                                     <div class="unStartInfor">
                                        <p class="competename">
                                            {{elem.competition_name}} {{elem.gameweek}}
                                            <span class="text-gray">{{elem.status}}</span>
                                        </p>
                                        <p class="vs">vs</p>

                                        <AppMatchTag v-if="elem.live_icon" :type="elem.live_icon.type"/>
                                    </div>
                                </div>

                                <!-- 正在进行中比赛 -->
                                <div v-else-if="elem.status==='Playing'" class="statusPlaying_competewrap competewrap" >
                                    <div class="playingUnLive">
                                        <p class="competename">
                                            {{elem.competition_name}} {{elem.gameweek}}
                                            <span class="playingUnliveTime">{{elem.playing_time}}'</span>
                                        </p>

                                        <p class="playingScore">
                                            <span>{{elem.fs_A}}</span><em class="dot">:</em><span>{{elem.fs_B}}</span>
                                        </p>

                                        <AppMatchTag v-if="elem.live_icon" :type="elem.live_icon.type"/>
                                    </div>
                                </div>

                                <!-- 已结束比赛 -->
                                <div v-else-if="elem.status==='Played'" class="statusEnd_competewrap competewrap" >
                                    <p class="competename">
                                        {{elem.competition_name}} {{elem.gameweek}}
                                        <span class="status">akhir</span>
                                    </p>
                                    <p class="compete-center mb5">
                                        <span>{{elem.fs_A}}</span><em class="line"></em><span>{{elem.fs_B}}</span>
                                    </p>

                                    <AppMatchTag v-if="elem.live_icon" :type="elem.live_icon.type"/>
                                </div>

                                <div v-else class="text-vs">vs</div>

                                <dl class="frwrap">
                                    <dt><img class="teamlogo" v-team-logo :data-src="getImgSrc(elem.team_B_logo)"></dt>
                                    <dd>{{elem.team_B_name}}</dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>

                <DownloadFooter v-if="getDownloadFooterShow" text="Unduh All Sepakbola untuk lebih banyak pertandingan" />
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from 'vuex';
    import DownloadFooter from '@/components/downloadFooter.vue';
    import navVue from '@/components/navNew.vue';
    import loading from '@/components/loading.vue';
    import nodata from '@/components/nodata.vue';
    import downloadPopup from '@/components/downloadPopup.vue';
    import AppMatchTag from '@/components/AppMatchTag.vue';

    export default {
        name: 'app',
        components: {
            DownloadFooter,
            navVue,
            loading,
            nodata,
            downloadPopup,
            AppMatchTag
        },
        data () {
            return {
                currentNavTag: 'COCOK',
                scroll: 0,
                is_jump: true, // 是否跳转到锚点
                isOperamini: false,
                headerHeight:0
            };
        },
        computed: {
            ...mapGetters([
                'getMatchSubTabList',
                'getMatchLoading',
                'getMatchNoDataMode',
                'getMatchLoadingShow',
                'getDownloadFooterShow',
                'getCurrentMatchListData',
                'getFinalListSplitDateData'
            ]),
            subtitChoose () {
                return this.$store.state.navStore.subtitChoose;
            },
            lastEndMatch() {
                const list = Object.values(this.getFinalListSplitDateData).flatMap(item => item.filter(e => e.status === 'Played'))
                return list.length ? list[list.length - 1] : null
            }
        },

        asyncData ({ store, route: { params: { subtitle,title } } }) {
            let allFetch = async () => {
                let menus = await store.dispatch('menusListApi', { subtitle, type: 'COCOK' });
                const chooseArr = store.getters.getMatchSubTabList.filter(ele => {
                    return ele.label === store.state.navStore.subtitChoose;
                });

                const urlApi = (chooseArr && chooseArr.length && chooseArr[0].urlApi) || '';
                let matchList = await store.dispatch('matchListApi', { urlApi });

                return Promise.all([
                    menus,
                    matchList
                ]);
            };
            return allFetch();
        },

        mounted() {
            let that = this;
            this.onScroll = function () {
                let utilObj = require('@/util/util.js');
                utilObj.lazyload('listwrap', 'teamlogo');
                that.stickyFn();
            };
            window.addEventListener('scroll', this.onScroll, false);
            let utilObj = require('@/util/util.js');
            utilObj.timeForInOut();
            this.isOperamini = utilObj.checkOperamini();

            // 获取头部元素的高度
            this.headerHeight = document.querySelector('#topFixedWrap').offsetHeight
            this.scrollToAnchor()
        },

        updated: function () {
            console.log('update:||||||||');
            let utilObj = require('@/util/util.js');
            utilObj.lazyload('listwrap', 'teamlogo');

            this.scrollToAnchor()
        },
        head () {
            const referer = this.subtitChoose
            return {
                title: `${referer} football matchs，Live Scores，Match analysis | All Sepakbola`,
                meta: [
                    {
                        name: 'description',
                        content: `The ${referer} football match details, including live text commentary, team line-ups, match analysis, odds...`
                    },
                    {
                        name: 'keywords',
                        content: `football app, allfootballapp.com,  ${referer} matchs, All Sepakbola, ${referer} live scores, ${referer} scores, `
                    }
                ]
            };
        },
        methods: {
            // 转换成12小时制方法
            tran12 (time) {
                let time_arr = time.split(':');
                if (time_arr[0] > 12) {
                    var result = (time_arr[0] - 12) + ':' + time_arr[1] + ' FM';
                } else {
                    var result = time_arr[0] + ':' + time_arr[1] + ' AM';
                }
                return result;
            },

            stickyFn(ev) {
                window.browers = {};
                var ua = navigator.userAgent.toLowerCase();
                browers.Android = ua.match(/android/);
                browers.iOS = ua.match(/ipad|iphone|ios/);
                if (browers.Android) {
                    let topFixedWrap = document.getElementById('topFixedWrap');
                    if (!topFixedWrap) {
                        return;
                    }
                    let topFixedWrapHeight = topFixedWrap.offsetHeight; // 被定住的位置的高度
                    this.scroll = document.body.scrollTop;

                    let headHeight = 0; // 下载条的高度
                    let contentWrap = document.getElementById('contentWrap'); // 每个二级导航下的列表内容
                    if (this.scroll >= headHeight) {
                        topFixedWrap.className = 'topFixedWrap tab-box-fixed';
                        contentWrap.style.paddingTop = topFixedWrapHeight + 'px';
                    } else {
                        topFixedWrap.className = 'topFixedWrap';
                        contentWrap.style.paddingTop = 0 + 'px';
                    }
                }
            },

            scrollToAnchor() {
                if (process.browser) {
                    this.$nextTick(() => {
                        if (!this.lastEndMatch) return

                        const anchor = document.querySelector(`#match-${this.lastEndMatch.match_id}`)

                        if (!anchor) return
                        // 获取目标元素的位置,并减去头部高度
                        const scrollTop = anchor.offsetTop - this.headerHeight

                        window.scrollTo({
                            top: scrollTop
                        })
                    })
                }
            },

            handleJumpMatchDetailPage(match) {
                const link = this.buildMatchDetailPageLink(match)
                const matchTag = match.live_icon || {}

                localStorage.setItem('match_tag', JSON.stringify(matchTag))
                window.location.href = link
            },

            buildMatchDetailPageLink(match) {
                const teamAName = encodeURIComponent(match.team_A_name.replace(/\s/g, '-'))
                const teamBName = encodeURIComponent(match.team_B_name.replace(/\s/g, '-'))
                const matchId = match.match_id

               return `/match/${this.subtitChoose}/${teamAName}-vs-${teamBName}/${matchId}`;
            }
        }
    }
</script>

<style lang="less" scoped>
    .listwrap {
        height: auto;
        overflow: hidden;
    }

    .dateTit {
        text-align: center;
        color: #8c9399;
        font-size: .8rem;
        margin: 0 auto;
        height: 2rem;
        line-height: 2rem;
        background: #eff1f4;
    }

    .list {
        height: 5.4rem;
        overflow: hidden;
        position: relative;
        border-bottom: 1px solid #eff1f4;
        background: #fff;
    }

    .list dl {
        width: 6.4rem;
    }

    .list dl dt {
        width: 2.2rem;
        height: 2.2rem;
        overflow: hidden;
        text-align: center;
        margin: 0 auto .4rem;
    }

    .list dl dt img {
        width: 100%;
        display: block;
    }

    .list dl dd {
        text-align: center;
        font-size: 0.68rem;
        color: #606369;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .flwrap {
        float: left;
        margin: .9rem 0 .9rem .6rem;
    }

    .frwrap {
        float: right;
        margin: .9rem .6rem .9rem 0;
    }

    .line {
        width: .6rem;
        height: .12rem;
        display: inline-block;
        background: #333d46;
        position: relative;
        top: -0.4rem;
        margin: 0 1rem;
    }

    .text-vs{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        text-align: center;
        height: 100%;
        text-align: center;
        font-size: 1.2rem;
        color: #606369;
    }

    .competewrap {
        box-sizing: border-box;
        font-size: 1.2rem;
        width: 10.4rem;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        margin-top: .58rem;
    }

    .competename {
        font-size: 12px;
        line-height: 14px;
        color: #8c9399;
        // margin-bottom: 0.5rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .compete-center {
        margin: .43rem 0;
    }

    .status {
        font-size: 12px;
        line-height: 14px;
        color: #8c9399
    }

    .dot {
        color: #16b13a;
        width: 2rem;
        display: inline-block;
        position: relative;
        top: -0.04rem;
        font-size: 1rem;
        font-style: normal;
    }

    .playingScore, playingLive {
        color: #16b13a;
        margin-bottom: 0.4rem;
        line-height: 1.2rem;
    }

    .playingUnliveTime {
        color: #16b13a;
        font-size: 0.8rem;
    }

    .statusPlaying_competewrap .competename {
        margin-bottom: 0.4rem;
    }

    .video_arrow {
        width: 0.36rem;
        height: 0.5rem;
        float: left;
        margin: 0.3rem 0.2rem 0 0.5rem;
    }

    .unStart_competewrap {
        color: #606369;
        font-size: 1rem;
    }

    .statusPlaying_competewrap {
        color: #16b13a;
    }

    .statusEnd_competewrap {
        color: #2d2f32;
    }

    .vs {
        line-height: 1.2rem;
        color: #606369;
        font-size: 1.2rem;
        margin: 0.59rem 0;
    }

    .unStartLive {
        color: #16ac3a;
        font-size: 0.6rem;
        width: 2.4rem;
        height: 1rem;
        border: 1px solid #16ac3a;
        display: inline-block;
        line-height: 1rem;
        border-radius: 0.01rem;
        position: relative;
        left: -0.1rem;
        top: 0rem;
        transform: scale(0.7);
    }

    .unStartTime,
    .text-gray{
        color: #8c9399;
        font-size: 0.68rem;
        line-height: 12px;
    }

    .loadwrap {
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2rem;
        color: #8c9399;
        background: #eff1f4;
        text-align: center;
        margin: 0 !important;
        line-height: 2rem;
        font-size: 0.68rem;
    }

    .loadingicon {
        width: 1rem;
        height: 1rem;
        background: url(../assets/home/loading-icon.png) no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: .5rem;
        left: 0rem;

        animation: rotate linear 1.2s both infinite;
        -webkit-animation: rotate linear 1.2s both infinite;
    }

    .loading {
        width: 6rem;
        margin: 0 auto;
        height: 2rem;
        line-height: 2rem;
        position: relative;
    }

    @keyframes rotate {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        50% {
            -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @keyframes rotate {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        50% {
            -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    .loadingtext {
        text-indent: 0.4rem;
        display: inline-block;
    }

    .contentWrap {
        min-height: 38rem;
    }

    .operamini-tips {
        background: #FFFF00;
        text-align: center;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// AppMatch.vue?7e10d3b0